import { convertMetersToUnits, decimals } from './jsHelper';
import { errorToast, successToast } from './toastHelper';
import {
  resetObjectPositionAlongAxis,
  setIsObjectSelectionStyleable,
  setObjectPositionAlongAxis,
} from '../redux/slicers/admin/curatorUnityObjectSlicer';
import {
  selectActiveMeasureUnitsName,
  selectCursorMode,
  setAllPropsLoaded,
  setBooleanOperationProcessing,
  setCuratorLoader,
  setGraphicQuality,
  setGroupPropInitialized,
  setGroupPropJsonData,
  setGroupPropLoadedCompletely,
  setLibraryPropInstantiated,
  setLightEffectActive,
  setObjectSelectionActive,
  setRoomInitialized,
  setRoomLoadedCompletely,
  setSelectedGraphicQuality,
  toggleSelectedAxis,
} from '../redux/slicers/admin/curatorSlicer';
import {
  setGlobalDPR,
  setLightEffectDisabledFromUnity,
} from '../redux/slicers/utilities/utilitiesSlicer';
import {
  setPasteMaterialLoading,
  setUnityObjectImagesProcessing,
} from '../redux/slicers/admin/curatorLoaderSlicer';

import { CURSOR_MODE } from '../config/constant/unityConstants';
import { FOV_MIN_VALUE } from '../config/constant/projectConstant';
import { LogConsole, LogCurator } from './logEvents';
import PubSub from 'pubsub-js';
import { curatorExclusivePropsActions } from '../redux/slicers/admin/curatorExclusivePropSlicer';
import { curatorLoadingProgressBarActions } from '../redux/slicers/admin/curatorLoadingProgressBarSlicer';
import { dispatcher } from './projectHelper';
import { getAppState } from '../redux/store';
import { setAutomation } from '../redux/slicers/admin/curatorAutomationSlicer';
import { setCuratorNotSaved } from '../pages/admin/curator/curatorState';
import { setGlobalFov } from '../redux/slicers/camera/cameraSettings';
import { setMetadata } from '../redux/slicers/admin/curatorMetadataSlicer';
import { throttle } from 'lodash';
import { undoRedo } from '../components/admin/curator/UndoRedo/UndoRedo';
import { ModifyCutawayLayer, unityContext } from '../components/container/unityContainer';
import {
  selectExpandedCameraId,
  selectProjectCameraList,
} from '../redux/slicers/camera/projectCameraAngleSlicer';
import { updateCameraData } from '../redux/slicers/camera/cameraEditSlicer';
import { upload3DModelProductActions } from '../redux/slicers/upload3DModelProductSlicer';
import {
  retailAutomationActions,
  TAB,
} from '../redux/slicers/retailAutomation/retailAutomation.slicer';
import { selectUserpilotState } from '../redux/slicers/activitySlicer';
import { userPilotEvents } from '../common/Userpilot/userpilotHelper';
import { isRetailAutomation } from '../components/Configurator/utils';
import { openTab } from '../redux/slicers/retailAutomation/retailAutomation.actions';
import {
  isMattressBuilderPage,
  isRetailAutomationPage,
} from '../components/admin/curator/ProductBuilderComponents/commonHelper';
const { trackCameraRotateEvent, trackCameraPanEvent, trackCameraZoomInOutEvent, goToNextStep } =
  userPilotEvents();

export const UnityEvent = {
  // unity events
  FocusObjectNameReceiver: 'FocusObjectNameReceiver',
  SwitchTransformTypeReceiver: 'SwitchTransformTypeReceiver',
  AllPropsLoaded: 'AllPropsLoaded',
  GetRoomInfo: 'GetRoomInfo',
  GetGroupPropsInfo: 'GetGroupPropsInfo',
  GetSelectedObjectInfoOnSelection: 'GetSelectedObjectInfoOnSelection',
  PredefinedCameraDetailsReceiver: 'PredefinedCameraDetailsReceiver',
  GetLightData: 'GetLightData',
  CameraFocalLengthReceiver: 'CameraFocalLengthReceiver',
  UpdatedFovReceiver: 'UpdatedFovReceiver',
  OnLibraryPropInstantiated: 'OnLibraryPropInstantiated',
  OnReceiveObjectPositionAlongAxis: 'OnReceiveObjectPositionAlongAxis',
  OnReceieveCurrentCameraScreenshot: 'OnReceieveCurrentCameraScreenshot',
  ReceiveBase64StringGenerateMap: 'ReceiveBase64StringGenerateMap',
  OnDeleteOperationCompleted: 'OnDeleteOperationCompleted',
  OnPropInstantiation: 'OnPropInstantiation',
  AllImagesOfObjectProcessed: 'AllImagesOfObjectProcessed',
  ReceiveSelectedObjectInfo: 'ReceiveSelectedObjectInfo',
  PasteMaterialPropertiesFinishedReceive: 'PasteMaterialPropertiesFinishedReceive',
  OnReceiveUpdatedCameraDetailsForOldZipFile: 'OnReceiveUpdatedCameraDetailsForOldZipFile',
  CameraDetailsReceiver: 'CameraDetailsReceiver',
  SelectedLightReceiver: 'SelectedLightReceiver',
  OnRoomLoadedCompletely: 'OnRoomLoadedCompletely',
  ReceiveObjectInfoBeforePasteMaterial: 'ReceiveObjectInfoBeforePasteMaterial',
  OnReceiveUpdatedPasteMaterialData: 'OnReceiveUpdatedPasteMaterialData',
  ApplyMaterialPropertiesFinishedReceive: 'ApplyMaterialPropertiesFinishedReceive',
  SelectedVariationPropFinished: 'SelectedVariationPropFinished', // Added to ensure SelectMaterialUsingMaterialNameForRetailAutomation is triggered only after receiving SelectedVariationPropFinished from Unity
  OnGroupPropLoadedForRetailAutomationCompletely: 'OnGroupPropLoadedForRetailAutomationCompletely',
  OnDeleteRoomMetadata: 'OnDeleteRoomMetadata',
  OnDeleteAutomation: 'OnDeleteAutomation',
  OnReceiveRoomMetadata: 'OnReceiveRoomMetadata',
  OnReceiveAutomationData: 'OnReceiveAutomationData',
  OnEditMetadataComplete: 'OnEditMetadataComplete',
  OnEditAutomationComplete: 'OnEditAutomationComplete',
  OnPropsDuplicate: 'OnPropsDuplicate', // callback fired when prop is placed somewhere -> provides placement information about object
  OnReplacePropCompletedReceiver: 'OnReplacePropCompletedReceiver', // callback fired when prop is replaced successfully
  UnselectTheAxisReceiver: 'UnselectTheAxisReceiver',
  OnMessageReceivedFromUnity: 'OnMessageReceivedFromUnity',
  OnReceiveSpaceState: 'OnReceiveSpaceState',
  CurrentViewCameraDetailsReceiver: 'CurrentViewCameraDetailsReceiver',
  OnReceiveExclusivePropData: 'OnReceiveExclusivePropData',
  DisableCustomCursorReceiver: 'DisableCustomCursorReceiver',
  RightClickCallbackReceiver: 'RightClickCallbackReceiver',
  pasteMaterialPossibleReceiver: 'pasteMaterialPossibleReceiver',
  ClickedObjectIsStyleAbleReceive: 'ClickedObjectIsStyleAbleReceive',
  SendLightEffectsAutomation: 'SendLightEffectsAutomation',
  SendQualityModeAutomation: 'SendQualityModeAutomation',
  OnCameraNavigate: 'OnCameraNavigate',
  SendDPRAutomation: 'SendDPRAutomation',
  OnMaterialApplied: 'OnMaterialApplied',
  UpdatedCameraDetailsReceiver: 'UpdatedCameraDetailsReceiver',
  OnPropInstantiateNameReceiver: 'OnPropInstantiateNameReceiver',
  OnReceiveIsUsedStatusOfTextures: 'OnReceiveIsUsedStatusOfTextures',
  OnReInstantiateDuplicateObjectCompleted: 'OnReInstantiateDuplicateObjectCompleted',
  OnInitializeRoom: 'OnInitializeRoom',
  OnInitializeGroupProp: 'OnInitializeGroupProp',
  OnGroupPropLoadedCompletely: 'OnGroupPropLoadedCompletely',
  UNITY_LOADED: 'UNITY_LOADED',
  ROOM_INITIALIZED: 'ROOM_INITIALIZED',
  REPLACE_PROP_DONE: 'REPLACE_PROP_DONE',
  OnReceiveObjectScreenPosition: 'OnReceiveObjectScreenPosition',
  OnDragCompletedReceiver: 'OnDragCompletedReceiver',
  OnReplacePropOperationCompleted: 'OnReplacePropOperationCompleted',
  OnMaterialApplyOperationCompleted: 'OnMaterialApplyOperationCompleted',
  OnToggleScreenLoader: 'OnToggleScreenLoader',
  GetUnityAlbedomap: 'GetUnityAlbedomap',
  GetUnityRoughnessmap: 'GetUnityRoughnessmap',
  GetUnityNormalmap: 'GetUnityNormalmap',
  FloorTextureGenerationCompleted: 'FloorTextureGenerationCompleted',
  GetTilingAndOffset: 'GetTilingAndOffset',
  GetHeightAndWidth: 'GetHeightAndWidth',
  GetUnityMettalicmap: 'GetUnityMettalicmap',
  ResizeTexture: 'ResizeTexture',
  ReceiveRenderInProgressCallback: 'ReceiveRenderInProgressCallback',
  GetEditInCuratorInfo: 'GetEditInCuratorInfo',
  GetLoadedConfiguratorInfo: 'GetLoadedConfiguratorInfo',
  GetLoadedLifestyleInfo: 'GetLoadedLifestyleInfo',
  OnReceiveBooleanOperationProcessingStatus: 'OnReceiveBooleanOperationProcessingStatus',
  OnReceiveCheckCancelAlignmentStatus: 'OnReceiveCheckCancelAlignmentStatus',
  ReceiveAlignmentReferenceStatus: 'ReceiveAlignmentReferenceStatus',
  UnityLoadedReceiver: 'UnityLoadedReceiver',
  ProductLoadedReceiver: 'ProductLoadedReceiver',
  ReceiveRetailAutomationPropData: 'ReceiveRetailAutomationPropData',
  ReceiveRetailAutomationPropDataForRainbowRack: 'ReceiveRetailAutomationPropDataForRainbowRack',
  OnCameraRotate: 'OnCameraRotate',
  OnCameraPan: 'OnCameraPan',
  OnCameraZoomInOut: 'OnCameraZoomInOut',
  OnReceiveDefaultMaterialPropertiesForRetailAutomation:
    'OnReceiveDefaultMaterialPropertiesForRetailAutomation',
  OnReceiveBrokenMaterialName: 'OnReceiveBrokenMaterialName',
  OnDeleteRetailMaterialReciever: 'OnDeleteRetailMaterialReciever',
  GetRetailPropTransformInfo: 'GetRetailPropTransformInfo',
  OnReceiveObjectDataForDuplicatedRetailProp: 'OnReceiveObjectDataForDuplicatedRetailProp',
  OnReceiveCurrentComponents: 'OnReceiveCurrentComponents',
  OnAllReplacedPropCompletedReceiver: 'OnAllReplacedPropCompletedReceiver',
  OnProductTypeChanged: 'OnProductTypeChanged',
  OnProductAddedReceiver: 'OnProductAddedReceiver',
  OnProductModifiedReceiver: 'OnProductModifiedReceiver',
  ReceiveDisplacementMapChanged: 'ReceiveDisplacementMapChanged',
  OnCurrentComponentsUpdate: 'OnCurrentComponentsUpdate',
  OnViewChanged: 'OnViewChanged',
  ReceiveSavedMaterialData: 'ReceiveSavedMaterialData',
  OnReceiveMaterialPropertiesofGivenObject: 'OnReceiveMaterialPropertiesofGivenObject',
  OnHeightChangedForProductBuilder: 'OnHeightChangedForProductBuilder',
  IsEmptySelectedShelfReceiver: 'IsEmptySelectedShelfReceiver',
  OnHeightExceededForProduct: 'OnHeightExceededForProduct',
  OnProductOutsideBound: 'OnProductOutsideBound',
  ObjectWillNotFitReceiver: 'ObjectWillNotFitReceiver',
  OnDeleteComponentForProductBuilder: 'OnDeleteComponentForProductBuilder',
  AllImagesOfObjectProcessedForProductBuilder: 'AllImagesOfObjectProcessedForProductBuilder',
  OnDefaultTextureApplyCompleted: 'OnDefaultTextureApplyCompleted',
  OnButtonExitedBounds: 'OnButtonExitedBounds',
  OnAddButtonConfigurationExitedBounds: 'OnAddButtonConfigurationExitedBounds',
  AllGroupPropsAreNotSelected: 'AllGroupPropsAreNotSelected',
  ModifyCutawayLayer :'ModifyCutawayLayer',
  OnRetailSceneLoaded: 'OnRetailSceneLoaded',
  OnReceiveListOfPropLoadedInRack: 'OnReceiveListOfPropLoadedInRack',
  IsEmptyRackReceiver: 'IsEmptyRackReceiver',
  OnLayerCollidedWithTop: 'OnLayerCollidedWithTop',
  OnReceiveButtonPresetConfiguration: 'OnReceiveButtonPresetConfiguration'
};

export const UnityErrorCode = {
  COPY_MATERIAL_FAILED: 'MAT06',
  PASTE_MATERIAL_FAILED: 'MAT05',
};

export const AppEvent = {
  ResolveTextureConflicts: 'ResolveTextureConflicts',
  ReceiveSelectedObjectInfoHandled: 'ReceiveSelectedObjectInfoHandled',
  RENDER_IMAGE_UPLOADED: 'RENDER_IMAGE_UPLOADED',
  DOWNLOAD_START: 'DOWNLOAD_STARTED',
  DOWNLOAD_UPDATE: 'DOWNLOAD_UPDATE',
  DOWNLOAD_FAILED: 'DOWNLOAD_FAILED',
  UPLOAD_START: 'UPLOAD_STARTED',
  UPLOAD_UPDATE: 'UPLOAD_UPDATE',
  UPLOAD_FAILED: 'UPLOAD_FAILED',
};

export const KEYBOARD_EVENT = {
  ESC_PRESSED: 'ESC_PRESSED',
};

window.FocusObjectNameReceiver = (dataJson) => {
  if (!dataJson) return;

  const data = JSON.parse(dataJson);
  PubSub.publish(UnityEvent.FocusObjectNameReceiver, data);
  dispatcher(setObjectSelectionActive(false));
};

window.SwitchTransformTypeReceiver = (message) => {
  PubSub.publish(UnityEvent.SwitchTransformTypeReceiver, message);
};

window.AllPropsLoaded = () => {
  const data = {
    method: 'props-loaded',
    data: { id: 'loaded' },
  };
  // TODO: this is some old implementation -> refactor it later
  window.postMessage(data);
  dispatcher(setAllPropsLoaded(true));
  dispatcher(curatorLoadingProgressBarActions.setMessage('Applying materials and textures'));
  PubSub.publish(UnityEvent.AllPropsLoaded, {});
};

window.GetRoomInfo = (roomInfo) => {
  // localStorage.setItem('roomInfo', roomInfo);
  LogCurator('roomInfo', {
    roomInfo,
    roomInfoJson: roomInfo ? JSON.parse(roomInfo) : {},
  });
  PubSub.publish(UnityEvent.GetRoomInfo, roomInfo !== '' ? JSON.parse(roomInfo) : roomInfo);
};

window.GetGroupPropsInfo = (groupPropInfo) => {
  LogCurator('groupPropInfo', JSON.parse(groupPropInfo));
  dispatcher(setGroupPropJsonData(JSON.parse(groupPropInfo)));
  PubSub.publish(UnityEvent.GetGroupPropsInfo, JSON.parse(groupPropInfo));
};

window.OnInitializeRoom = () => {
  dispatcher(setRoomInitialized(true));
  PubSub.publish(UnityEvent.ROOM_INITIALIZED);
};

window.OnInitializeGroupProp = () => {
  LogCurator('OnInitializeGroupProp');
  dispatcher(setGroupPropInitialized(true));
  PubSub.publish(UnityEvent.OnInitializeGroupProp);
};

window.OnGroupPropLoadedCompletely = (groupPropDataJson) => {
  LogCurator('OnGroupPropLoadedCompletely', groupPropDataJson);
  const objectList = JSON.parse(groupPropDataJson);
  undoRedo.unityObject.addProp({ objectList });
  dispatcher(setGroupPropLoadedCompletely(true));
  PubSub.publish(UnityEvent.OnGroupPropLoadedCompletely, objectList);
};

export const pubSubState = {
  isDuplicate: false, // changes to true to when we duplicating an object -> so in the next `GetSelectedObjectInfoOnSelection` we know that it's not selection but duplication of an object. It would be great if unity informs react about it
};

window.GetSelectedObjectInfoOnSelection = (objectListJson) => {
  const { isDuplicate } = pubSubState;
  pubSubState.isDuplicate = false;

  const { isGizmoHighlighted } = selectUserpilotState(getAppState());
  if (isGizmoHighlighted) goToNextStep();

  const objectList = JSON.parse(objectListJson) || [];
  const isTransformAction = objectList && objectList.length > 0 && objectList[0].isTransformChanged;
  LogCurator('GetSelectedObjectInfoOnSelection', objectList);

  if (isTransformAction) {
    // transformation
    undoRedo.unityObject.trasnform({ objectList });
    setCuratorNotSaved();
    return;
  }

  if (undoRedo?.unityObject?.replacePropInProgress) {
    // replace prop flow. It's triggered few times we're interested in new object only and ignore old objects
    if (objectList.length > 0) {
      PubSub.publish(UnityEvent.REPLACE_PROP_DONE, objectList);
    }
  } else if (isDuplicate) {
    undoRedo.unityObject.savePrevObjectListForDuplicateUndoSelection();
  } else {
    // object selection

    setTimeout(() => {
      // we need timeout to make sure other events will be finalized by pubsub before select happens -> for example when we add light -> we wait for callback which informs that light is added -> there is PubSub subscription which waits for that event -> and if we don't have timeout then add light be finalized only after light will be selected which is incorrect order as first we need to add light and only after that it can be selected
      undoRedo.unityObject.selectObject({ objectList });
    });
  }
  if (isRetailAutomation()) {
    if (objectList?.length) {
      dispatcher(retailAutomationActions.setClickedUnityObjectPartInfo(objectList));
    } else {
      if (window.location.href.includes('/style')) {
        openTab(TAB.AUTOMATION);
      }
      dispatcher(retailAutomationActions.setCardIndexClicked(null));
      dispatcher(retailAutomationActions.setCurrentSelectedTexture(null));
    }
  }

  PubSub.publish(UnityEvent.GetSelectedObjectInfoOnSelection, objectList);
};

window.PredefinedCameraDetailsReceiver = (cameraPresetsJson) => {
  const cameraPresetsList = JSON.parse(cameraPresetsJson);
  PubSub.publish(UnityEvent.PredefinedCameraDetailsReceiver, cameraPresetsList);
};

window.GetLightData = (roomLightDataJson) => {
  let roomLightData = JSON.parse(roomLightDataJson);
  if (roomLightData) {
    roomLightData = roomLightData?.filter((_item) => !_item.isLightDeleted);
  }
  PubSub.publish(UnityEvent.GetLightData, roomLightData);
};

window.CameraFocalLengthReceiver = (focalLengthString) => {
  const focalLength = parseFloat(focalLengthString);
  PubSub.publish(UnityEvent.CameraFocalLengthReceiver, focalLength);
};

window.UpdatedFovReceiver = (fovValue) => {
  dispatcher(setGlobalFov(decimals(fovValue, 4) || FOV_MIN_VALUE));
  PubSub.publish(UnityEvent.UpdatedFovReceiver, fovValue);
};

window.OnLibraryPropInstantiated = () => {
  dispatcher(setLibraryPropInstantiated(true));
  PubSub.publish(UnityEvent.OnLibraryPropInstantiated);
  console.log('DEBUG___OnLibraryPropInstantiated');
  setCuratorNotSaved();
};

const updateFunc = throttle((value, transformType) => {
  const cursorMode = selectCursorMode(getAppState());
  if (cursorMode === CURSOR_MODE.MOVE) {
    const unitsName = selectActiveMeasureUnitsName(getAppState());
    value = value === '-' ? value : convertMetersToUnits(value, unitsName);
  }
  dispatcher(
    setObjectPositionAlongAxis({
      value,
      transformType,
    })
  );
}, 49);

window.OnReceiveObjectPositionAlongAxis = (value, transformType) => {
  updateFunc(value, transformType);
};

window.OnReceieveCurrentCameraScreenshot = (imageData) => {
  PubSub.publish(UnityEvent.OnReceieveCurrentCameraScreenshot, imageData);
};

window.AllImagesOfObjectProcessed = () => {
  LogCurator('Curator', 'AllImagesOfObjectProcessed');
};

window.ReceiveBase64StringGenerateMap = (objectName, mapType, imageInfo) => {
  PubSub.publish(UnityEvent.ReceiveBase64StringGenerateMap, {
    objectName,
    mapType,
    imageInfo,
  });
};

window.OnDeleteOperationCompleted = (objectListJson) => {
  const objectList = JSON.parse(objectListJson);
  undoRedo.unityObject.delete({ objectList });
  LogCurator('OnDeleteOperationCompleted', objectList);
  PubSub.publish(UnityEvent.OnDeleteOperationCompleted, { objectList });
  setCuratorNotSaved();
};

window.AllImagesOfObjectProcessed = () => {
  LogCurator('AllImagesOfObjectProcessed');
  setUnityObjectImagesProcessing(false);
  PubSub.publish(UnityEvent.AllImagesOfObjectProcessed);
};

window.CameraDetailsReceiver = (cameraJson) => {
  const cameraData = JSON.parse(cameraJson);
  PubSub.publish(UnityEvent.CameraDetailsReceiver, { cameraData });
};

window.OnPropInstantiation = (propDataJson) => {
  LogCurator('OnPropInstantiation', propDataJson);
  const propData = JSON.parse(propDataJson);
  const objectList = [propData];
  // TODO: move everything related to undoredo to oundoredo class
  if (undoRedo?.unityObject?.addProp) {
    undoRedo.unityObject.addProp({ objectList });
  }
  PubSub.publish(UnityEvent.OnPropInstantiation, objectList);
};

window.ReceiveSelectedObjectInfo = (data) => {
  if (data) PubSub.publish(UnityEvent.ReceiveSelectedObjectInfo, data);
};

window.SelectedLightReceiver = (lightJson) => {
  PubSub.publish(UnityEvent.SelectedLightReceiver, JSON.parse(lightJson));
};

export const waitForEventOnce = (eventName, funcOrData) => {
  let triggerFunc;

  if (typeof funcOrData === 'function') {
    triggerFunc = funcOrData;
  } else if (funcOrData?.triggerFunc) {
    triggerFunc = funcOrData.triggerFunc;
  }

  return new Promise((resolve) => {
    PubSub.subscribeOnce(eventName, (_, data) => {
      resolve(data);
    });

    triggerFunc?.();
  });
};

export const waitForEvent = (eventName, funcOrData) => {
  let triggerFunc;

  if (typeof funcOrData === 'function') {
    triggerFunc = funcOrData;
  } else if (funcOrData?.triggerFunc) {
    triggerFunc = funcOrData.triggerFunc;
  }

  return new Promise((resolve) => {
    PubSub.subscribe(eventName, (_, data) => {
      resolve(data);
    });

    triggerFunc?.();
  });
};

window.PasteMaterialPropertiesFinishedReceive = (...args) => {
  if (!isMattressBuilderPage()) {
    setPasteMaterialLoading(false);
  }
  LogCurator('PasteMaterialPropertiesFinishedReceive', ...args);
  PubSub.publish(UnityEvent.PasteMaterialPropertiesFinishedReceive);
  setCuratorNotSaved();
};

window.OnReceiveUpdatedCameraDetailsForOldZipFile = (cameraListJson) => {
  const cameraList = JSON.parse(cameraListJson);
  PubSub.publish(UnityEvent.OnReceiveUpdatedCameraDetailsForOldZipFile, cameraList);
};

window.ReceiveObjectInfoBeforePasteMaterial = (objectDataJson) => {
  // LogCurator("Curator",'ReceiveObjectInfoBeforePasteMaterial', )
  PubSub.publish(UnityEvent.ReceiveObjectInfoBeforePasteMaterial, JSON.parse(objectDataJson));
};

window.OnRoomLoadedCompletely = () => {
  LogCurator('OnRoomLoadedCompletely');
  console.warn('room has been loaded completely');
  dispatcher(setRoomLoadedCompletely(true));
  PubSub.publish(UnityEvent.OnRoomLoadedCompletely);
};

window.OnReceiveUpdatedPasteMaterialData = (dataJson) => {
  const data = JSON.parse(dataJson);
  PubSub.publish(UnityEvent.OnReceiveUpdatedPasteMaterialData, data);
  setCuratorNotSaved();
};

window.ApplyMaterialPropertiesFinishedReceive = () => {
  LogCurator(
    'Curator',
    'UNITY_OBJECT__COPY_PASTE_MATERIAL pub sub ApplyMaterialPropertiesFinishedReceive'
  );
  PubSub.publish(UnityEvent.ApplyMaterialPropertiesFinishedReceive);
};

window.ModifyCutawayLayer = (data) => {
  LogCurator(
    'Curator',
    'UNITY_OBJECT__COPY_PASTE_MATERIAL pub sub ModifyCutawayLayer'
  );
  PubSub.publish(UnityEvent.ModifyCutawayLayer);
  ModifyCutawayLayer(data)
}

// Added to ensure SelectMaterialUsingMaterialNameForRetailAutomation is triggered only after receiving SelectedVariationPropFinished from Unity
window.SelectedVariationPropFinished = () => {
  LogCurator('Curator', 'SelectedVariationPropFinished');
  PubSub.publish(UnityEvent.SelectedVariationPropFinished);
};

window.OnGroupPropLoadedForRetailAutomationCompletely = () => {
  LogCurator('Curator', 'OnGroupPropLoadedForRetailAutomationCompletely');
  PubSub.publish(UnityEvent.OnGroupPropLoadedForRetailAutomationCompletely);
};

window.OnDeleteRoomMetadata = (status) => {
  PubSub.publish(UnityEvent.OnDeleteRoomMetadata, status);
  setCuratorNotSaved();
};

window.OnEditMetadataComplete = (status) => {
  PubSub.publish(UnityEvent.OnEditMetadataComplete, status);
  setCuratorNotSaved();
};

window.OnDeleteAutomation = (status) => {
  PubSub.publish(UnityEvent.OnDeleteAutomation, status);
  setCuratorNotSaved();
};

window.OnEditAutomationComplete = (status) => {
  PubSub.publish(UnityEvent.OnEditAutomationComplete, status);
  setCuratorNotSaved();
};

window.OnPropsDuplicate = (dataJson) => {
  const data = JSON.parse(dataJson);
  LogCurator('OnPropsDuplicate', data);
  PubSub.publish(UnityEvent.OnPropsDuplicate, data);
  setCuratorNotSaved();
};

window.OnReplacePropCompletedReceiver = () => {
  PubSub.publish(UnityEvent.OnReplacePropCompletedReceiver);
};

window.UnselectTheAxisReceiver = (axis) => {
  // TODO: add validation
  dispatcher(toggleSelectedAxis(axis));
  dispatcher(resetObjectPositionAlongAxis());
};

window.CurrentViewCameraDetailsReceiver = (cameraJson) => {
  const cameraData = JSON.parse(cameraJson);

  const editCameraId = selectExpandedCameraId(getAppState());
  const cameraList = selectProjectCameraList(getAppState());

  const cameraToUpdate = cameraList.find((cam) => cam.id === editCameraId);
  if (cameraToUpdate) {
    dispatcher(
      updateCameraData({
        id: cameraToUpdate?.id,
        lensShiftY: cameraData?.lensShiftY,
        cameraRotX: cameraData?.cameraRotX,
      })
    );
  }
  console.log('DEBUG_CurrentViewCameraDetailsReceiver', {
    cameraData,
    cameraToUpdate,
    editCameraId,
    cameraList,
  });

  PubSub.publish(UnityEvent.CurrentViewCameraDetailsReceiver, cameraData);
};

window.OnReceiveSpaceState = (globalActive) => {
  PubSub.publish(UnityEvent.OnReceiveSpaceState, parseInt(globalActive));
};

window.OnMessageReceivedFromUnity = (messageJson) => {
  LogCurator('messageJson: ', messageJson);
  const message = JSON.parse(messageJson);

  if (message.messageCode === 'MAT05') {
    // message: "Material is already applied."
  }

  const toast = message.isError ? errorToast : successToast;
  toast(message.message);
  PubSub.publish(UnityEvent.OnMessageReceivedFromUnity, message);
};

window.OnReceiveExclusivePropData = (propListJson) => {
  const propList = JSON.parse(propListJson);
  dispatcher(curatorExclusivePropsActions.setPropList(propList));
  PubSub.publish(UnityEvent.OnReceiveExclusivePropData, propList);
};

window.DisableCustomCursorReceiver = () => {
  dispatcher(setObjectSelectionActive(false));
  PubSub.publish(UnityEvent.DisableCustomCursorReceiver);
};

window.OnReceiveRoomMetadata = (metadataJson) => {
  LogCurator('OnReceiveRoomMetadata', metadataJson);
  if (!metadataJson) return;

  try {
    const metadata = JSON.parse(metadataJson);
    dispatcher(setMetadata(metadata));
    PubSub.publish(UnityEvent.OnReceiveRoomMetadata, metadata);
  } catch (e) {
    // TODO: add logger here
    console.error(e);
  }
};

window.OnReceiveAutomationData = (automationJson) => {
  LogCurator('OnReceiveAutomationData', automationJson);
  if (!automationJson) return;

  try {
    let automation = JSON.parse(automationJson);
    automation = automation.map((a) => {
      return {
        ...a,
        title: a.automationName,
      };
    });
    dispatcher(setAutomation(automation));
    PubSub.publish(UnityEvent.OnReceiveAutomationData, automation);
  } catch (e) {
    // TODO: add logger here
    console.error(e);
  }
};

window.RightClickCallbackReceiver = () => {
  LogCurator('RightClickCallbackReceiver');
  PubSub.publish(UnityEvent.RightClickCallbackReceiver);
};

window.pasteMaterialPossibleReceiver = () => {
  PubSub.publish(UnityEvent.pasteMaterialPossibleReceiver);
};

window.ClickedObjectIsStyleAbleReceive = (isStyleableNumber) => {
  const isStyleable = Boolean(isStyleableNumber);
  dispatcher(setIsObjectSelectionStyleable(isStyleable));
  PubSub.publish(UnityEvent.ClickedObjectIsStyleAbleReceive, isStyleable);
};

window.SendQualityModeAutomation = (qualityIndex) => {
  // The Value will be 0-Fantastic, 1-Good, 2-Performance
  if (window.location.pathname.includes('curator')) {
    dispatcher(setGraphicQuality({ quality: parseInt(qualityIndex) }));
  }
};

window.SendLightEffectsAutomation = (activeText) => {
  const active = activeText === 'true';
  dispatcher(setLightEffectActive(Boolean(active)));
  dispatcher(setLightEffectDisabledFromUnity(true));
};

window.SendDPRAutomation = (dprValue) => {
  const newDpr = parseFloat(dprValue);
  dispatcher(setGlobalDPR(newDpr));
  unityContext.unityInstance.Module.devicePixelRatio = newDpr;
};

window.UpdatedCameraDetailsReceiver = (cameraJSON) => {
  const cameraData = JSON.parse(cameraJSON);
  PubSub.publish(UnityEvent.UpdatedCameraDetailsReceiver, cameraData);
};

window.OnPropInstantiateNameReceiver = (objectName) => {
  dispatcher(curatorLoadingProgressBarActions.setMessage(`Loading ${objectName}`));
  PubSub.publish(UnityEvent.OnPropInstantiateNameReceiver, objectName);
};

window.OnCameraNavigate = () => {
  PubSub.publish(UnityEvent.OnCameraNavigate);
};

window.OnMaterialApplied = () => {
  dispatcher(curatorLoadingProgressBarActions.addLoadedMaterial());
};

window.GetRoomInfoForAutoSave = () => {};

window.OnReceiveIsUsedStatusOfTextures = (data) => {
  PubSub.publish(UnityEvent.OnReceiveIsUsedStatusOfTextures, JSON.parse(data));
};

window.OnReInstantiateDuplicateObjectCompleted = () => {
  PubSub.publish(UnityEvent.OnReInstantiateDuplicateObjectCompleted);
};

window.OnReceiveObjectScreenPosition = (data) => {
  PubSub.publish(UnityEvent.OnReceiveObjectScreenPosition, JSON.parse(data));
};

window.OnDragCompletedReceiver = () => {
  PubSub.publish(UnityEvent.OnDragCompletedReceiver);
};

window.OnMaterialApplyOperationCompleted = () => {
  PubSub.publish(UnityEvent.OnMaterialApplyOperationCompleted);
};

window.OnReplacePropOperationCompleted = (data) => {
  LogCurator('OnReplacePropOperationCompleted: ', data);
  PubSub.publish(UnityEvent.OnReplacePropOperationCompleted, JSON.stringify(data));
};

window.OnToggleScreenLoader = (flag) => {
  LogCurator('OnToggleScreenLoader: ', flag);
  dispatcher(setCuratorLoader(flag === 'true' || flag === true ? false : true));
};

window.GetUnityAlbedomap = (roomLightDataJson) => {
  const mapData = roomLightDataJson;
  PubSub.publish(UnityEvent.GetUnityAlbedomap, mapData);
};

window.GetUnityNormalmap = (roomLightDataJson) => {
  const mapData = roomLightDataJson;
  PubSub.publish(UnityEvent.GetUnityNormalmap, mapData);
};

window.GetUnityRoughnessmap = (roomLightDataJson) => {
  const mapData = roomLightDataJson;
  PubSub.publish(UnityEvent.GetUnityRoughnessmap, mapData);
};

window.FloorTextureGenerationCompleted = (data) => {
  PubSub.publish(UnityEvent.FloorTextureGenerationCompleted, data);
};

window.GetTilingAndOffset = (roomLightDataJson) => {
  const mapData = roomLightDataJson;
  PubSub.publish(UnityEvent.GetTilingAndOffset, mapData);
};

window.GetHeightAndWidth = (roomLightDataJson) => {
  const mapData = roomLightDataJson;
  PubSub.publish(UnityEvent.GetHeightAndWidth, mapData);
};

window.GetUnityMettalicmap = (roomLightDataJson) => {
  const mapData = roomLightDataJson;
  PubSub.publish(UnityEvent.GetUnityMettalicmap, mapData);
};

window.ResizeTexture = (dataJson) => {
  const mapData = dataJson;
  PubSub.publish(UnityEvent.ResizeTexture, mapData);
};

window.ReceiveRenderInProgressCallback = (dataJson) => {
  const mapData = dataJson;
  PubSub.publish(UnityEvent.ReceiveRenderInProgressCallback, mapData);
};

window.GetLoadedConfiguratorInfo = (dataJson) => {
  const mapData = dataJson;
  PubSub.publish(UnityEvent.GetLoadedConfiguratorInfo, mapData);
};

window.GetLoadedLifestyleInfo = (dataJson) => {
  const mapData = dataJson;
  PubSub.publish(UnityEvent.GetLoadedLifestyleInfo, mapData);
};

window.OnReceiveBooleanOperationProcessingStatus = (value) => {
  const _value = value.toLowerCase();
  dispatcher(setBooleanOperationProcessing(_value === 'true'));
  PubSub.publish(UnityEvent.OnReceiveBooleanOperationProcessingStatus, _value);
};

window.OnReceiveCheckCancelAlignmentStatus = (data) => {
  PubSub.publish(UnityEvent.OnReceiveCheckCancelAlignmentStatus, data);
};

window.ReceiveAlignmentReferenceStatus = (data) => {
  PubSub.publish(UnityEvent.ReceiveAlignmentReferenceStatus, data);
};

// will be called when 3D Model Product unity is loaded.
window.UnityLoadedReceiver = () => {
  LogCurator('UnityLoadedReceiver____Unity Loaded');
  dispatcher(upload3DModelProductActions.setProduct3DModelUnitySceneLoaded(true));
};
// will be called when 3D Model Product is loaded in the unity.
window.ProductLoadedReceiver = () => {
  dispatcher(upload3DModelProductActions.setProduct3DModelAssetLoaded(true));
};

// Retail Automation Module Receivers ---- BEGINS
window.ReceiveRetailAutomationPropData = (data) => {
  LogCurator('DEBUG__ReceiveRetailAutomationPropData', JSON.parse(data));
  if (data && typeof data === 'string') {
    const parsedData = JSON.parse(data);
    
    const rackShelfCount = +parsedData?.rackShelfCount || 0;
    if (rackShelfCount > 0) dispatcher(retailAutomationActions.setRackShelfCount(rackShelfCount));

    if (parsedData?.isChildProp) {
      dispatcher(retailAutomationActions.setReplacePropResponseRecieved(parsedData));
    } else {
      // sort on the basis number after _ in material names
      parsedData.materialName = parsedData.materialName.sort((a, b) => {
        // Extract the part after the underscore and convert it to a number
        const numA = parseInt(a.split('_')[1], 10);
        const numB = parseInt(b.split('_')[1], 10);

        return numA - numB; // Compare numerically
      });
      dispatcher(retailAutomationActions.setPropDataReceivedFromUnity(parsedData));
    }
    PubSub.publish(UnityEvent.ReceiveRetailAutomationPropData, parsedData);
  }
};

window.ReceiveRetailAutomationPropDataForRainbowRack = (data) => {
  LogConsole('DEBUG__ReceiveRetailAutomationPropDataForRainbowRack', JSON.parse(data));
  if (data && typeof data === 'string') {
    const parsedList = JSON.parse(data)?.map((item) => ({
      ...item,
      materialName: item.materialName.sort((a, b) => {
        // Extract the part after the underscore and convert it to a number
        const numA = parseInt(a.split('_')[1], 10);
        const numB = parseInt(b.split('_')[1], 10);

        return numA - numB; // Compare numerically
      }),
    }));
    parsedList.forEach((item) => {
      if (item?.isChildProp) {
        dispatcher(retailAutomationActions.setReplacePropResponseRecieved(item));
      } else {
        dispatcher(retailAutomationActions.setPropDataReceivedFromUnity(item));
      }
    });
  }
};

window.OnReceiveDefaultMaterialPropertiesForRetailAutomation = (data) => {
  LogCurator(
    'DEBUG__OnReceiveGetDefaultMaterialDataByMaterialNameForRetailAutomation',
    JSON.parse(data)
  );
  dispatcher(retailAutomationActions.setArtworkDefaultCombinations(JSON.parse(data)));
};
// Retail Automation Module Receivers ---- ENDS

window.OnCameraRotate = () => {
  trackCameraRotateEvent();

  const { isCameraRotate } = selectUserpilotState(getAppState());
  if (isCameraRotate) goToNextStep();
};

window.OnCameraPan = () => {
  trackCameraPanEvent();

  const { isCameraPan } = selectUserpilotState(getAppState());
  if (isCameraPan) goToNextStep();
};

window.OnCameraZoomInOut = () => {
  trackCameraZoomInOutEvent();

  const { isCameraZoomInOut } = selectUserpilotState(getAppState());
  if (isCameraZoomInOut) goToNextStep();
};

window.OnReceiveBrokenMaterialName = (data) => {
  PubSub.publish(UnityEvent.OnReceiveBrokenMaterialName, data);
};

window.OnDeleteRetailMaterialReciever = (data) => {
  PubSub.publish(UnityEvent.OnDeleteRetailMaterialReciever, data);
};

window.GetRetailPropTransformInfo = (data) => {
  PubSub.publish(UnityEvent.GetRetailPropTransformInfo, JSON.parse(data));
};

window.OnReceiveObjectDataForDuplicatedRetailProp = (data) => {
  PubSub.publish(UnityEvent.OnReceiveObjectDataForDuplicatedRetailProp, JSON.parse(data));
};

window.OnReceiveCurrentComponents = (data) => {
  LogCurator('currentComponent', {
    currentComponents: JSON.parse(data),
  });
  PubSub.publish(UnityEvent.OnReceiveCurrentComponents, JSON.parse(data));
};

window.OnAllReplacedPropCompletedReceiver = (data) => {
  LogCurator('OnAllReplacedPropCompletedReceiver');
  PubSub.publish(UnityEvent.OnAllReplacedPropCompletedReceiver);
};

window.OnProductTypeChanged = () => {
  PubSub.publish(UnityEvent.OnProductTypeChanged);
};

window.OnProductModifiedReceiver = () => {
  LogCurator('OnProductModifiedReceiver');
  PubSub.publish(UnityEvent.OnProductModifiedReceiver);
};

window.OnProductAddedReceiver = () => {
  PubSub.publish(UnityEvent.OnProductAddedReceiver);
};

window.ReceiveDisplacementMapChanged = () => {
  LogCurator('ReceiveDisplacementMapChanged');
  PubSub.publish(UnityEvent.ReceiveDisplacementMapChanged);
};

window.OnCurrentComponentsUpdate = () => {
  PubSub.publish(UnityEvent.OnCurrentComponentsUpdate);
};

window.OnViewChanged = () => {
  LogCurator('OnViewChanged');
  PubSub.publish(UnityEvent.OnViewChanged);
};

window.ReceiveSavedMaterialData = (data) => {
  PubSub.publish(UnityEvent.ReceiveSavedMaterialData, JSON.parse(data));
};

window.OnReceiveMaterialPropertiesofGivenObject = (data) => {
  PubSub.publish(UnityEvent.OnReceiveMaterialPropertiesofGivenObject, JSON.parse(data));
};

window.OnHeightChangedForProductBuilder = () => {
  LogCurator('OnHeightChangedForProductBuilder');
  PubSub.publish(UnityEvent.OnHeightChangedForProductBuilder);
};

window.IsEmptySelectedShelfReceiver = (data) => {
  PubSub.publish(UnityEvent.IsEmptySelectedShelfReceiver, JSON.parse(data));
};

window.OnHeightExceededForProduct = (data) => {
  PubSub.publish(UnityEvent.OnHeightExceededForProduct, JSON.parse(data));
};

window.OnProductOutsideBound = () => {
  PubSub.publish(UnityEvent.OnProductOutsideBound);
};

window.ObjectWillNotFitReceiver = (data) => {
  PubSub.publish(UnityEvent.ObjectWillNotFitReceiver, data);
};

window.OnDeleteComponentForProductBuilder = (data) => {
  PubSub.publish(UnityEvent.OnDeleteComponentForProductBuilder, data ? JSON.parse(data) : []);
};

window.AllImagesOfObjectProcessedForProductBuilder = () => {
  LogCurator('AllImagesOfObjectProcessedForProductBuilder');
  PubSub.publish(UnityEvent.AllImagesOfObjectProcessedForProductBuilder);
};

window.OnDefaultTextureApplyCompleted = () => {
  LogCurator('OnDefaultTextureApplyCompleted');
  PubSub.publish(UnityEvent.OnDefaultTextureApplyCompleted);
};

window.OnButtonExitedBounds = () => {
  LogCurator('OnButtonExitedBounds');
  PubSub.publish(UnityEvent.OnButtonExitedBounds);
};

window.OnAddButtonConfigurationExitedBounds = () => {
  LogCurator('OnAddButtonConfigurationExitedBounds');
  PubSub.publish(UnityEvent.OnAddButtonConfigurationExitedBounds);
};

window.AllGroupPropsAreNotSelected = () => {
  LogCurator('AllGroupPropsAreNotSelected');
  PubSub.publish(UnityEvent.AllGroupPropsAreNotSelected, { allGroupPropsAreNotSelected: true });
};
window.OnRetailSceneLoaded = () => {
  LogCurator('OnRetailSceneLoaded');
  PubSub.publish(UnityEvent.OnRetailSceneLoaded);
};

window.OnReceiveListOfPropLoadedInRack = (list) => {
  PubSub.publish(UnityEvent.OnReceiveListOfPropLoadedInRack, JSON.parse(list));
};

window.IsEmptyRackReceiver = (list) => {
  PubSub.publish(UnityEvent.IsEmptyRackReceiver, JSON.parse(list));
};

window.OnLayerCollidedWithTop = (data) => {
  PubSub.publish(UnityEvent.OnLayerCollidedWithTop, JSON.parse(data));
};

window.OnReceiveButtonPresetConfiguration = (objectDataJson) => {
  LogCurator('OnReceiveButtonPresetConfiguration', objectDataJson )
  PubSub.publish(UnityEvent.OnReceiveButtonPresetConfiguration, JSON.parse(objectDataJson));
};